module.exports = __webpack_public_path__ + "img/media-4.ee3b9507.png";